import { FinanciadoraModel } from "../../dominio/financiadora-model";

export class CommonFinanceModel {
  idVinculo: number;
  idFinanciadora: number;
  nomeFinanciadora: string;
  imagem?: string | null;
  statusFinSimulacao: number;
  financiadora: FinanciadoraModel | null;
  statusMsg?: string;
  expirou?: boolean;
  justificativaNegativa?: string | null;

  // Propriedades auxiliares do frontend
  imagem$?: any;
  buscouImagem?: boolean;
  semImagem?: boolean;
  limparDados?: boolean;
}
